/* eslint-disable sonarjs/no-duplicate-string */
import AxiosInstance from 'config/apiServiceApiGateway'
import { Get } from 'config/apiServiceConfig'

export type ProductVendorType = {
  id: number
  vendor: {
    id: number
    name: string
    company_name: string
  }
  preference: number
  pic_vendor: {
    id: number
    name: string
  }
  pic_sourcing: {
    id: number
    name: string
    full_name: string
  }
  locations: {
    id: number
    name: string
    type: string
  }[]
  price: number
  rebate: number
  scheduled_prices: {
    id: number | null
    price: number
    rebate: number
    effective_date: string
    sync_to_pricing_engine: boolean
    sync_to_rl: boolean
  }[]
}

export type ProductVendorPaginationType = {
  total_elements: number
  page_index: number
  page_size: number
  next_cursor: ''
  prev_cursor: ''
}

export type GetProductVendorsResponseType = {
  data: ProductVendorType[]
  pagination: ProductVendorPaginationType
}

export type PostProductVendorDataType = {
  product_id: number
  pic_sourcing: number
  vendor_id: number
  preference: number
  product_price: number
  rebate?: number
  location_ids: number[]
  scheduled_prices: {
    id: number | null
    effective_date: string
    price: number
    rebate: number
    sync_to_pricing_engine: boolean
    sync_to_rl: boolean
  }[]
}

export type PutProductVendorDataType = {
  pic_sourcing: number
  product_price: number
  rebate: number
  location_ids: number[]
  scheduled_prices: {
    id: number | null
    effective_date: string
    price: number
    rebate: number
    sync_to_pricing_engine: boolean
    sync_to_rl: boolean
  }[]
}

export type ProductDetailType = {
  product_name: string
}

export type PicSourcingType = {
  id: number
  full_name: string
}

export const getProductDetailApi = (productId: number) =>
  Get<ProductDetailType>({
    url: `/api/product/${productId}`,
  })

export const getProductVendorsApi = (product_id: number, cursor = '', vendor_name = '') =>
  AxiosInstance.Get<GetProductVendorsResponseType, true>({
    url: '/commercial/internal/:version/product-vendors',
    version: 'v1',
    params: {
      product_id,
      cursor,
      vendor_name,
    },
  })

export const getProductVendorDetailsApi = (id: number) =>
  AxiosInstance.Get<{ data: ProductVendorType }, true>({
    url: '/commercial/internal/:version/product-vendors/:id',
    version: 'v1',
    urlParams: { id },
  })

export const postProductVendorApi = (data: PostProductVendorDataType) =>
  AxiosInstance.Post({
    url: '/commercial/internal/:version/product-vendors',
    version: 'v1',
    data,
  })

export const putProductVendorApi = (vendorId: string, data: PutProductVendorDataType) =>
  AxiosInstance.Put({
    url: '/commercial/internal/:version/product-vendors/:vendorId',
    version: 'v1',
    urlParams: { vendorId },
    data,
  })

export const deleteProductVendorApi = (id: number) =>
  AxiosInstance.Delete({
    url: '/commercial/internal/:version/product-vendors/:id',
    version: 'v1',
    urlParams: { id },
  })

export const patchProductVendorPreferenceApi = (id: number) =>
  AxiosInstance.Patch({
    url: '/commercial/internal/:version/product-vendors/:id',
    version: 'v1',
    urlParams: { id },
    data: { preference: 1 },
  })

export const getProductVendorCounts = (product_ids: string) =>
  AxiosInstance.Get<{ data: { produc_id: number; total_vendor: number } }, true>({
    url: '/commercial/internal/:version/product-vendors/vendor-counts',
    version: 'v1',
    params: {
      product_ids,
    },
  })

export const getProductVendorFeatureFlagApi = () =>
  AxiosInstance.Get<{ data: { FF_ENABLE_VENDOR_CATALOG_MIGRATION_ALLOYDB: string } }, true>({
    url: '/commercial/internal/:version/feature-flags?flags=FF_ENABLE_VENDOR_CATALOG_MIGRATION_ALLOYDB',
    version: 'v1',
  })

export const getPicSourcingApi = (name: string) =>
  Get<{ content: PicSourcingType[] }>({
    url: '/api/product/catalog/pic',
    params: {
      name,
      picId: 6807,
    },
  })
